import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "alert alert-success",
  style: {
    "max-width": "350px",
    "margin-bottom": "{{small ? 5 : 15}}px"
  },
  "data-cy": "product-notice"
};
const _hoisted_2 = {
  "ng-show": "!small"
};
import { reactive, onMounted } from 'vue';
import RouteService from '@/services/RouteService';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'ProductNotice',
  props: {
    label: {
      type: String,
      default: undefined
    },
    small: {
      type: Boolean,
      required: false
    },
    product: {
      type: String,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);
    const state = reactive({
      show: undefined,
      admin: undefined,
      trial: undefined
    });
    onMounted(async () => {
      await meStore.getMe();
      state.admin = me.value.access.setup;
      state.show = !me.value.features[props.product];
      state.trial = me.value.company.products.trial;
    });
    const goToSubscription = () => {
      const routeService = new RouteService({
        state: props.state
      });
      routeService.go('settings.company.maxioCompanySubscription');
    };
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", null, [_withDirectives(_createElementVNode("span", null, _toDisplayString(__props.label) + " not available in your subscription. ", 513), [[_vShow, !state.trial]]), _withDirectives(_createElementVNode("span", null, "Upgrade now or speak with our success team for more information.", 512), [[_vShow, state.admin && !state.trial && !__props.small]]), _withDirectives(_createElementVNode("span", null, "Please talk to your LeanLaw administrator to upgrade your account.", 512), [[_vShow, !state.admin && !state.trial && !__props.small]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.label) + " enabled during your trial but only available with certain subscription options after your trial expires.", 513), [[_vShow, state.trial]]), _withDirectives(_createElementVNode("span", null, [...(_cache[1] || (_cache[1] = [_createElementVNode("br", null, null, -1), _createElementVNode("a", {
        href: "https://leanlaw.co/pricing",
        target: "_blank",
        rel: "noopener noreferrer"
      }, [_createTextVNode(" Learn More "), _createElementVNode("span", {
        class: "fa fa-external-link"
      })], -1)]))], 512), [[_vShow, __props.small]])]), _createElementVNode("p", _hoisted_2, [_withDirectives(_createVNode(LlSecondaryButton, {
        color: "primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => goToSubscription(), ["prevent"]))
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, "Subscribe", 512), [[_vShow, state.trial]]), _withDirectives(_createElementVNode("span", null, "Upgrade Now", 512), [[_vShow, !state.trial]])]),
        _: 1
      }, 512), [[_vShow, state.admin]]), _createVNode(LlSecondaryButton, {
        href: "https://leanlaw.co/pricing",
        target: "_blank",
        rel: "noopener noreferrer",
        class: "ml-5"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" Learn More ", -1), _createElementVNode("span", {
          class: "fa fa-external-link"
        }, null, -1)]))]),
        _: 1
      })])], 512)), [[_vShow, state.show]]);
    };
  }
};